import React from 'react';
import { StoreDetailProps } from 'util/Props';
import AppointmentCTA from 'containers/AppointmentCTA';
import StoreDetailsBase from 'components/StoreDetailsBase';
import config from 'config';
/**
    Store details should be used anytime brief store information is displayed on the page, including address,
    my store indicator and make an appointment CTA.
*/
class MazamaStoreDetailsBrief extends StoreDetailsBase {
    //add class to selectedStoreID to show the different styles for the selected ID store
    //() => to pass the store id to prop function
    componentDidUpdate() {
        if (this.props.isSelectedStore && this.element) {
            this.element.closest(
                '.storeList'
            ).scrollTop = this.element.parentNode.offsetTop;
        }
    }
    render() {
        let address = [];
        let storeDetalsClass = 'storeDetails storeDetails--brief';
        let tempStyle = { color: '#0e6fb4' };
        if (this.props.isSelectedStore || this.props.isMystore) {
            storeDetalsClass += ' storeDetails--selected';
        }
        address.push(this.props.city);
        address.push(this.props.stateCode);
        address.push(this.props.postalCode);
        return (
            <div
                ref={div => {
                    this.element = div;
                }}
                className={storeDetalsClass}
                onClick={() => this.props.setSelectedStore(this.props.id)}
            >
                {/*
                        Address Information
                */}
                <address>
                    <span className="storeDetails__streetName" key={address}>
                        {this.props.index != null && this.props.index + 1 + '. '}
                        {this.props.address1}{' '}
                    </span>
                    <br />
                    <span>{this.formatAddress(address)}</span>
                    {this.props.distance && (
                    <span className="storeDetails__distance">
                        <strong>
                            {`${this.roundDistance(this.props.distance)} ${
                                    config.distanceMeasurement
                                }`}
                        </strong>
                    </span>
                    )}
                    <a
                        className="storeDetails__mobileDetailsLink"
                        href={this.props.storeDetailsUrl}
                        title={this.props.storeDetailsLabel}
                        aria-label={this.props.storeDetailsLabel}
                    />
                </address>
                {/*
                        Contact, ordering is important due to mobile + desktop being different
                */}
                <ul className="storeDetails__contact">
                    {this.props.phone && !this.props.noPhoneMessage && (
                    <li className="show-for-medium">
                        <span>{this.formatPhone()}</span>
                    </li>
                    )}
                    {this.props.noPhoneMessage && (
                    <li className="show-for-medium">
                        <span>{this.props.noPhoneMessage}</span>
                    </li>
                    )}
                    <li className="show-for-small-only">
                        <a
                            className="button button--gray"
                            href={this.getDirections()}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {this.props.directionsLabel}
                        </a>
                    </li>
                    <li>
                        <a
                            className="show-for-medium"
                            style={tempStyle}
                            href={this.getDirections()}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {this.props.directionsLabel}
                        </a>
                        {this.props.phone && !this.props.noPhoneMessage && (
                        <a
                            className="show-for-small-only button button--gray"
                            href={'tel:' + this.props.phone}
                            >
                            Call Us
                        </a>
                        )}
                        {this.props.noPhoneMessage && (
                        <span className="show-for-small-only">
                            {this.props.noPhoneMessage}
                        </span>
                        )}
                    </li>
                    <li className="show-for-medium">
                        <a
                            href={this.props.storeDetailsUrl}
                            style={tempStyle}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {this.props.storeDetailsLabel}
                        </a>
                    </li>
                </ul>
                <div className="element-group">
                    {!this.props.disableAppointment && (
                    <AppointmentCTA
                        {...this.props.appointmentCTA}
                        storeId={this.props.id}
                        />
                    )}
                </div>
            </div>
        );
    }
}

MazamaStoreDetailsBrief.propTypes = StoreDetailProps;

export default MazamaStoreDetailsBrief;
